import React from "react";
import { getStatusBadgeClass, getStatusLabel } from "./utils";

export default function JobsManagerPanel({
  jobs,
  jobsEnabled,
  isAdmin,
  jobForm,
  updateJobField,
  savingJob,
  resetJobForm,
  handleSaveJob,
  handleEditJob,
  handleDeleteJob,
  isAr,
  isMobile,
}) {
  return (
    <div className="card border-0 shadow-sm mb-4 provider-center__panel-card">
      <div className="card-body">
        <div className="pc-section-head mb-3">
          <div className="pc-section-head__left">
            <span className="pc-icon-box pc-icon-box--red">
              <i className="bi bi-building" />
            </span>
            <h5 className="mb-0">{isAr ? "إدارة الوظائف" : "Manage jobs"}</h5>
          </div>
          <span className="badge text-bg-light">{jobs.length}</span>
        </div>

        {!jobsEnabled ? (
          <div className="alert alert-warning mb-0">
            {isAr ? "قسم الوظائف معطل حاليًا." : "The jobs section is currently disabled."}
          </div>
        ) : !isAdmin ? (
          <div className="alert alert-secondary mb-0">
            {isAr
              ? "إضافة الوظائف من هذه اللوحة مخصصة للأدمن فقط."
              : "Job creation from this dashboard is reserved for admins only."}
          </div>
        ) : (
          <>
            <div className="alert alert-info">
              {isAr
                ? "الوظائف من هذا القسم تدار من الأدمن مباشرة وتُنشر بحسابه."
                : "Jobs in this section are managed directly by the admin and published under the admin account."}
            </div>

            <form onSubmit={handleSaveJob}>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "عنوان الوظيفة بالعربية" : "Title Arabic"}</label>
                  <input className="form-control" value={jobForm.titleAr} onChange={(event) => updateJobField("titleAr", event.target.value)} />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "عنوان الوظيفة بالإنجليزية" : "Title English"}</label>
                  <input className="form-control" value={jobForm.titleEn} onChange={(event) => updateJobField("titleEn", event.target.value)} />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "وصف مختصر بالعربية" : "Short Description Arabic"}</label>
                  <textarea rows="2" className="form-control" value={jobForm.shortDescriptionAr} onChange={(event) => updateJobField("shortDescriptionAr", event.target.value)} />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "وصف مختصر بالإنجليزية" : "Short Description English"}</label>
                  <textarea rows="2" className="form-control" value={jobForm.shortDescriptionEn} onChange={(event) => updateJobField("shortDescriptionEn", event.target.value)} />
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "الوصف بالعربية" : "Description Arabic"}</label>
                  <textarea rows="3" className="form-control" value={jobForm.descriptionAr} onChange={(event) => updateJobField("descriptionAr", event.target.value)} />
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "الوصف بالإنجليزية" : "Description English"}</label>
                  <textarea rows="3" className="form-control" value={jobForm.descriptionEn} onChange={(event) => updateJobField("descriptionEn", event.target.value)} />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "الشركة" : "Company"}</label>
                  <input className="form-control" value={jobForm.company} onChange={(event) => updateJobField("company", event.target.value)} />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "نوع التوظيف" : "Employment Type"}</label>
                  <select className="form-select" value={jobForm.employmentType} onChange={(event) => updateJobField("employmentType", event.target.value)}>
                    <option value="full-time">{isAr ? "دوام كامل" : "Full-time"}</option>
                    <option value="part-time">{isAr ? "دوام جزئي" : "Part-time"}</option>
                    <option value="remote">{isAr ? "عن بعد" : "Remote"}</option>
                    <option value="contract">{isAr ? "عقد" : "Contract"}</option>
                    <option value="internship">{isAr ? "تدريب" : "Internship"}</option>
                    <option value="freelance">{isAr ? "حر" : "Freelance"}</option>
                  </select>
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "الموقع" : "Location"}</label>
                  <input className="form-control" value={jobForm.location} onChange={(event) => updateJobField("location", event.target.value)} />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "الحد الأدنى للراتب" : "Salary Min"}</label>
                  <input type="number" min="0" step="0.01" className="form-control" value={jobForm.salaryMin} onChange={(event) => updateJobField("salaryMin", event.target.value)} />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "الحد الأعلى للراتب" : "Salary Max"}</label>
                  <input type="number" min="0" step="0.01" className="form-control" value={jobForm.salaryMax} onChange={(event) => updateJobField("salaryMax", event.target.value)} />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "نص الراتب" : "Salary Text"}</label>
                  <input className="form-control" value={jobForm.salaryText} onChange={(event) => updateJobField("salaryText", event.target.value)} />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "الخبرة المطلوبة" : "Experience Level"}</label>
                  <input className="form-control" value={jobForm.experienceLevel} onChange={(event) => updateJobField("experienceLevel", event.target.value)} />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "آخر موعد للتقديم" : "Application Deadline"}</label>
                  <input type="date" className="form-control" value={jobForm.applicationDeadline} onChange={(event) => updateJobField("applicationDeadline", event.target.value)} />
                </div>
                <div className="col-12 col-md-4 d-flex align-items-end">
                  <div className="form-check mb-2 me-3">
                    <input id="provider-job-active" type="checkbox" className="form-check-input" checked={jobForm.isActive} onChange={(event) => updateJobField("isActive", event.target.checked)} />
                    <label className="form-check-label" htmlFor="provider-job-active">
                      {isAr ? "الوظيفة نشطة" : "Job is active"}
                    </label>
                  </div>
                  <div className="form-check mb-2">
                    <input id="provider-job-featured" type="checkbox" className="form-check-input" checked={jobForm.isFeatured} onChange={(event) => updateJobField("isFeatured", event.target.checked)} />
                    <label className="form-check-label" htmlFor="provider-job-featured">
                      {isAr ? "مميزة" : "Featured"}
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "صورة الغلاف" : "Cover Image"}</label>
                  <input className="form-control" value={jobForm.coverImage} onChange={(event) => updateJobField("coverImage", event.target.value)} placeholder={isAr ? "رابط الصورة أو اسم الملف" : "Image URL or stored filename"} />
                </div>
              </div>

              <div className="d-flex gap-2 mt-3">
                <button className="btn btn-dark" type="submit" disabled={savingJob}>
                  {savingJob
                    ? isAr ? "جارٍ الحفظ..." : "Saving..."
                    : jobForm.id
                      ? isAr ? "تحديث الوظيفة" : "Update Job"
                      : isAr ? "إضافة الوظيفة" : "Add Job"}
                </button>
                {jobForm.id ? (
                  <button className="btn btn-outline-secondary" type="button" onClick={resetJobForm}>
                    {isAr ? "إلغاء" : "Cancel"}
                  </button>
                ) : null}
              </div>
            </form>

            <hr className="my-4" />

            {jobs.length === 0 ? (
              <div className="text-muted">
                {isAr ? "لا توجد وظائف مضافة حتى الآن." : "No jobs have been added yet."}
              </div>
            ) : isMobile ? (
              <div className="provider-center__mobile-list">
                {jobs.map((job) => (
                  <article className="provider-center__mobile-item" key={job.id}>
                    <div className="provider-center__mobile-head">
                      <div>
                        <div className="fw-semibold">{job.titleEn || job.titleAr || `#${job.id}`}</div>
                        <div className="small text-muted">
                          {job.company || job.location || job.slug}
                        </div>
                      </div>
                      <span className={`badge rounded-pill ${getStatusBadgeClass(job.approvalStatus)}`}>
                        {getStatusLabel(job.approvalStatus, isAr)}
                      </span>
                    </div>
                    <div className="provider-center__mobile-grid">
                      <div>
                        <div className="small text-muted">{isAr ? "التقديمات" : "Applications"}</div>
                        <div>{job.applicationsCount}</div>
                      </div>
                      <div>
                        <div className="small text-muted">{isAr ? "النوع" : "Type"}</div>
                        <div>{job.employmentType || "-"}</div>
                      </div>
                    </div>
                    <div className="provider-center__mobile-actions">
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleEditJob(job)}>
                        {isAr ? "تعديل" : "Edit"}
                      </button>
                      <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteJob(job)}>
                        {isAr ? "حذف" : "Delete"}
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>{isAr ? "الوظيفة" : "Job"}</th>
                      <th>{isAr ? "الحالة" : "Status"}</th>
                      <th>{isAr ? "الشركة" : "Company"}</th>
                      <th>{isAr ? "التقديمات" : "Applications"}</th>
                      <th>{isAr ? "الإجراءات" : "Actions"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobs.map((job) => (
                      <tr key={job.id}>
                        <td>
                          <div className="fw-semibold">{job.titleEn || job.titleAr || `#${job.id}`}</div>
                          <div className="small text-muted">
                            {(isAr ? job.shortDescriptionAr : job.shortDescriptionEn) || job.location || job.slug}
                          </div>
                        </td>
                        <td>
                          <span className={`badge rounded-pill ${getStatusBadgeClass(job.approvalStatus)}`}>
                            {getStatusLabel(job.approvalStatus, isAr)}
                          </span>
                        </td>
                        <td>{job.company || "-"}</td>
                        <td>{job.applicationsCount}</td>
                        <td>
                          <div className="d-flex gap-2 flex-wrap">
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleEditJob(job)}>
                              {isAr ? "تعديل" : "Edit"}
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteJob(job)}>
                              {isAr ? "حذف" : "Delete"}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
